<!-- 采购计划数据操作 -->
<template>
    <div>
        <el-dialog :visible.sync="dataActionBox.showStatus" width="80%" top="30px">
            <div class="demo-drawer__content">
                <el-form :model="sendDataInfo" ref="sendDataInfo" label-width="120px" class="demo-ruleForm">
                    <el-form-item label="货主名称" prop="coName" :rules="[{ required: true, message: '请选择货主名称', trigger: ['blur','change'] }]">
                        <el-tooltip class="item" :disabled="sendDataInfo.coName&&sendDataInfo.coName.length>7?false:true" effect="dark" :content="sendDataInfo.coName" placement="bottom-start">
                            <el-input style="width: 220px;" clearable v-model="sendDataInfo.coName" ref="coName" id="coName" @keyup.enter.native="openSearch(4414428383875072, '', 'coName', 'coName,coId')">
                                <el-button @click="openSearch(4414428383875072, '', 'coName','coName,coId')" slot="append" icon="el-icon-search"></el-button>
                            </el-input>
                        </el-tooltip>
                    </el-form-item>
                </el-form>
                <div style="margin-top: 20px;">
                    <el-button type="primary" size="mini" @click="addDetails('sendDataInfo')">新增一行</el-button>
                    <el-button type="danger" size="mini" @click="delDetails">删除一行</el-button>
                </div>
                <el-table size="mini" class="baseTable" ref="mxTableRef" :data="sendDataInfo.detailsList" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @selection-change="handleSelectionChange" border
                    style="width: 100%" height="400">
                    <el-table-column label="选择操作" width="80" v-if="dataActionBox.actionType != 2">
                        <template slot-scope="scope">
                            <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                <i class="el-icon-thumb"></i>
                            </el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="bgmName" label="通用名称" show-overflow-tooltip min-width="160">
                        <template slot-scope="scope">
                            <el-input clearable v-model="sendDataInfo.detailsList[scope.$index].bgmName" ref="bgmName" id="bgmName"
                                @keyup.enter.native="openSearch(4439374514425856, scope.$index, 'bgmName', 'bgmName,bgmCode,bgmId', 'bgmName')">
                                <el-button @click="openSearch(4439374514425856, scope.$index, 'bgmName', 'bgmName,bgmCode,bgmId', 'bgmName')" slot="append" icon="el-icon-search">
                                </el-button>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="lackNum" label="缺货数量" show-overflow-tooltip min-width="120">
                        <template slot-scope="scope">
                            <el-input type="number" v-model="sendDataInfo.detailsList[scope.$index].lackNum"></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="spec" label="规格" show-overflow-tooltip min-width="160"></el-table-column>
                    <el-table-column align="center" prop="manufacturer" label="生产厂家" show-overflow-tooltip min-width="160"></el-table-column>
                    <el-table-column align="center" prop="placeorigin" label="产地" show-overflow-tooltip min-width="100"></el-table-column>
                    <el-table-column align="center" prop="bgpUnitmeasurement" label="包装单位" show-overflow-tooltip min-width="100"></el-table-column>
                    <el-table-column align="center" prop="bgiType" label="商品分类" show-overflow-tooltip min-width="100"></el-table-column>
                    <el-table-column align="center" prop="stockNum" label="当前库存数量" show-overflow-tooltip min-width="120"></el-table-column>
                    <el-table-column align="center" prop="lastSmName" label="最后进货单位" show-overflow-tooltip min-width="120"></el-table-column>
                    <el-table-column align="center" prop="lastPrice" label="最后进货价格" show-overflow-tooltip min-width="120"></el-table-column>
                    <el-table-column align="center" prop="lastNum" label="最后进货数量" show-overflow-tooltip min-width="120"></el-table-column>
                    <el-table-column align="center" prop="salesNum" label="销量" show-overflow-tooltip min-width="120"></el-table-column>
                    <el-table-column align="center" prop="days" label="补货天数" show-overflow-tooltip min-width="120"></el-table-column>
                    <el-table-column align="center" prop="bgmRemarks" label="商品备注" show-overflow-tooltip min-width="120"></el-table-column>
                    <el-table-column align="center" prop="goodReserves5" label="采购员" show-overflow-tooltip min-width="120"></el-table-column>
                    <el-table-column align="center" prop="bgiBrand" label="品牌" show-overflow-tooltip min-width="120"></el-table-column>
                    <el-table-column align="center" prop="lowPrice" label="最低限价" show-overflow-tooltip min-width="120"></el-table-column>
                    <el-table-column align="center" prop="levlePrice" label="销售价" show-overflow-tooltip min-width="120"></el-table-column>
                </el-table>
                <div style="margin-top: 1rem;text-align: center;">
                    <el-button type="primary" @click="initActionBox">取消</el-button>
                    <el-button type="primary" @click="sendDataAction('sendDataInfo')">保存</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
        </el-dialog>
    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
export default {
    name: "purchasePlanAction",
    props: [],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                coId: "",
                coName: "",
                detailsList: [],
            },
            detailsObj: {
                mne:"",
                bgmName: "",
                bgmCode: "",
                bgmId: "",
                spec: "",
                manufacturer: "",
                placeorigin: "",
                bgpUnitmeasurement: "",
                bgiType: "",
                stockNum: 0,
                lackNum: 0,
                lastSmName: "",
                lastPrice: 0,
                lastNum: 0,
                salesNum: 0,
                days: 0,
                bgmRemarks: "",
                goodReserves5:"",
                bgiBrand:"",
                lowPrice:"",
                levlePrice:"",
            },
            showTabs: "",
            formDataList: [],
            seId: "",
            seWidth: "",
            height: "",
            seTitle: "",
            seWidth: "",
            DialogVisible: false,
            seType: "",
            sField: '',
            seIndex: 0,
            parentSearchData: {},
            selectedDetailsIndex: 0,
            selectedRow: []
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.detailsList": {
            handler: function (newValue, oldValue) {
                newValue.forEach((item,keys)=>{
                    this.$set(item, 'lackNum', this.$common.updataNum('lackNum', item).lackNum)
                })
            },
            deep:true,
        }
    },
    //方法集合
    methods: {
        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {};
            this.selectedDetailsIndex = row.rowIndex;
            findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },
        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {};
            if (row.bgColor && row.bgColor != "")
                rowBackground.backgroundColor = row.bgColor;
            return rowBackground;
        },
        handleChange(value, name) {
            console.log(value, name);
            // value默认参，name当前所需的name
            this.sendDataInfo[name] = value;
        },
        getSeWidth(e) {
            console.log(e);
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            console.log(e);
            this.seTitle = e;
        },
        //检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            this.DialogVisible = true;
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            if (type == "bgmName") {
                if (this.parentSearchData.bgmName) {
                    let fh = 0;
                    if (this.parentSearchData.bgmName.indexOf(",") != -1) {
                        fh = ",";
                    } else if (this.parentSearchData.bgmName.indexOf("，") != -1) {
                        fh = "，";
                    }
                    if (fh !== 0) {
                        const str = this.parentSearchData.bgmName;
                        const list = str.split(fh);
                        this.parentSearchData.bgmName = list[0] || "";
                        this.parentSearchData.manufacturer = list[1] || "";
                    } else {
                        this.parentSearchData.manufacturer = "";
                    }
                } else {
                    this.parentSearchData.bgmName = "";
                    this.parentSearchData.manufacturer = "";
                }
                return;
            }
            this.parentSearchData[type] = this.sendDataInfo[type]
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.sendDataInfo[item] = val[item]
            })
        },
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                if (this.seType == 'bgmName') {
                    for (const key in this.detailsObj) {
                        if (val[key] != undefined && val[key] != null) {
                            this.$set(this.sendDataInfo.detailsList[this.selectedDetailsIndex], key, val[key])
                        }
                    }
                } else {
                    this.paramValue(val)
                }
            }
        },
        initActionBox() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.pspmSupdays = 0;
            this.sendDataInfo.detailsList = []
            this.dataActionBox.actionType = 0;
            this.dataActionBox.showStatus = false;
        },

        openBox() {
            this.dataActionBox.boxTitle = "新增信息";
            this.dataActionBox.openMode = "ltr";
            this.dataActionBox.showStatus = true;
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.detailsList = []
            this.sendDataInfo.pspmSupdays = 0;
            this.dataActionBox.actionType = 0;
        },
        addDetails(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    if (this.sendDataInfo.detailsList.length == 0) {
                        this.sendDataInfo.detailsList.push({})
                        this.selectedDetailsIndex = 0
                        for (const key in this.detailsObj) {
                            this.$set(this.sendDataInfo.detailsList[this.selectedDetailsIndex], key, this.detailsObj[key])
                        }
                        this.$nextTick(()=>{
                            this.tableNextFocus();
                        })
                    } else {
                        var flag = false
                        this.sendDataInfo.detailsList.forEach((item, index) => {
                            if ((item.bgmName == '' || item.bgmName == null) && !flag) {
                                this.selectedDetailsIndex = index
                                flag = true
                            }
                        })
                        if (flag) {
                            return this.$message.error("请完善选中行")
                        }
                        this.sendDataInfo.detailsList.push({})
                        this.selectedDetailsIndex = this.sendDataInfo.detailsList.length - 1
                        for (const key in this.detailsObj) {
                            this.$set(this.sendDataInfo.detailsList[this.selectedDetailsIndex], key, this.detailsObj[key])
                        }
                        this.$nextTick(()=>{
                            this.tableNextFocus();
                        })
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        delDetails(){
            if (this.sendDataInfo.detailsList.length>0) {
                this.sendDataInfo.detailsList.splice(this.selectedDetailsIndex,1)
                this.selectedDetailsIndex=0
            }
        },
        // 表格切换焦点方法
        tableNextFocus() {
            this.$refs['bgmName'].focus();
        },
        sendDataAction(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sub();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });

        },
        async sub() {
            var flag=false
            this.sendDataInfo.detailsList.forEach((item,index)=>{
                item.coId=this.sendDataInfo.coId
                item.coName=this.sendDataInfo.coName
                if ((item.lackNum<=0||item.lackNum=="")&&!flag) {
                    this.selectedDetailsIndex=index
                    flag=true
                }
            })
            if (flag) {
                return this.$message.error("选中的数据中的缺货数量小于等于零")
            }
            this.$emit("addClick",this.sendDataInfo.detailsList)
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}
.table_content_box {
    /* height: 500px !important; */
    overflow-y: auto;
}
</style>